export default {"src":"/_next/static/media/xiaomi_logo.03b13455.svg","height":200,"width":200};